import React, { useEffect, useState } from "react";
import { useWindowSize } from "usehooks-ts";
import BannerDesktop from "./banner_desktop";
import BannerMobile from "./banner_mobile";

const CatgeoryBanner = () => {
  const { width } = useWindowSize();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  if (width < 992) {
    return <BannerMobile />;
  }

  return <BannerDesktop />;
};

export default CatgeoryBanner;
